import { apiSlice } from "../../apiSlice";

/**
 * Endpoints de visibilidad de Customs AI (proxy Laravel de solo lectura
 * al router /monitor del motor). El front usa su sesión sanctum normal.
 * @author Diego Serrano <diego.serrano@repremundo.com.co>
 * @since 2026-07-27
 */
export const customsaiApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getCustomsDoMonitor: builder.query({
      query: ({ DOCNROXX }) => ({
        url: `/Modimpxx/Customsai/getDoMonitor/${DOCNROXX}`,
        method: "GET",
      }),
    }),
    getCustomsBatches: builder.query({
      query: (params) => {
        const qs = new URLSearchParams();
        Object.entries(params ?? {}).forEach(([key, value]) => {
          if (value !== "" && value !== undefined && value !== null) qs.set(key, value);
        });
        const suffix = qs.toString() ? `?${qs.toString()}` : "";
        return { url: `/Modimpxx/Customsai/getBatches${suffix}`, method: "GET" };
      },
    }),
    getCustomsActivity: builder.query({
      query: (params) => ({
        url: `/Modimpxx/Customsai/getActivity${params?.mine ? "?MINE=SI" : ""}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetCustomsDoMonitorQuery,
  useGetCustomsBatchesQuery,
  useLazyGetCustomsBatchesQuery,
  useGetCustomsActivityQuery,
} = customsaiApiSlice;
